import { useQuery } from '@tanstack/react-query';

import Api from '@app/services/api';

import { PARTY_SUGGEST_MIN_QUERY_LENGTH, PARTY_SUGGEST_STALE_TIME_MS } from '../constants';

export const usePartySuggestQuery = (query: string) => {
  return useQuery({
    queryKey: ['dadata', 'party', 'suggest', query],
    queryFn: ({ signal }) => Api.daData.postSuggestParty(query, signal),
    enabled: query.length >= PARTY_SUGGEST_MIN_QUERY_LENGTH,
    staleTime: PARTY_SUGGEST_STALE_TIME_MS,
  });
};
